<template>
    <v-container>
        <v-data-table
            :headers="headers"
            :items="encounters"
            :items-per-page="-1"
            dense
            class="elevation-1"
            hide-default-footer
        >
            <template v-slot:[`item.encounterName`]="{ item }">
                <router-link :to="{ name: 'readEncounter', params: { id: item.encounterId } }" :title="item.name">
                    {{ item.encounterName }}
                </router-link>
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
import api from '@/api'
export default {
    name: 'PlotEncounters',
    props: {
        id: {
            type: [Number, String],
            required: true,
            validator: value => {
                return !!value
            },
        },
    },
    data() {
        return {
            isLoading: false,
            encounters: [],
            headers: [
                {
                    text: 'Event',
                    align: 'start',
                    value: 'eventName',
                },
                {
                    text: 'Name',
                    align: 'start',
                    value: 'encounterName',
                },
            ],
        }
    },
    mounted() {
        this.getEncounters()
    },
    methods: {
        getEncounters() {
            this.isLoading = true
            api.get(`plots/${this.id}/encounters`)
                .then(res => {
                    this.encounters = res
                })
                .finally(() => {
                    this.isLoading = false
                })
        },
    },
}
</script>
